// extracted by mini-css-extract-plugin
export default {"btnSave":"styles_btnSave__dx1q+","profileCloseIcon":"styles_profileCloseIcon__ZsW+d"};